import { api } from 'helpers/Api';
import { toDate } from 'helpers/Format';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.salesReport = function (range) {
        var salesReport;
        var today = new Date();
        return api.get("/invoice/totalsale/".concat(range)).then(function (totalSales) {
            var salesArray = totalSales.map(function (sales) { return sales.sales; });
            salesArray.unshift(0);
            if (totalSales.length > 3) {
                salesReport = {
                    saleDate: toDate(totalSales[0].saleDate),
                    sales: salesArray
                };
            }
            else {
                salesReport = {
                    saleDate: toDate(new Date()),
                    sales: totalSales.length > 0 ? salesArray : salesArray.unshift(0)
                };
            }
            return salesReport;
        });
    };
    default_1.prototype.customerReport = function (range) {
        return api.get("/invoice/salescustomers/".concat(range)).then(function (totals) { return totals; });
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Dashboard/Store.ts
// module id = 699
// module chunks = 0